import { render, staticRenderFns } from "./UninstallScreen.vue?vue&type=template&id=3631ad3e"
import script from "./UninstallScreen.vue?vue&type=script&lang=js"
export * from "./UninstallScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports